
'use strict';

var cart = require('base/cart/cart');

var updateMiniCart = true;
var popoverTimeout;

module.exports = function () {
    
    $('.minicart').on('mouseenter focusin touchstart', function () {
        if ($('.search:visible').length === 0) {
            return;
        }
        var url = $('.minicart').data('action-url');
        var count = parseInt($('.minicart .minicart-quantity').text(), 10);

            if (!updateMiniCart) {
                $('.minicart .popover').addClass('show');
                return;
            }

            $('.minicart .popover').addClass('show');
            $('.minicart .popover').spinner().start();
            $.get(url, function (data) {
                $('.minicart .popover').empty();
                $('.minicart .popover').append(data);
                updateMiniCart = false;
                $.spinner().stop();
            });
    });
    $('body').on('product:afterAddToCart', function () {
    updateMiniCart = true;

    $('.minicart').trigger('mouseenter');

    $('.minicart, .minicart .popover').on('mouseenter', function () {
        if (popoverTimeout) {
            clearTimeout(popoverTimeout);
        }
    });

    popoverTimeout = setTimeout(function () {
        $('.minicart .popover').removeClass('show');
        popoverTimeout = null;
    }, 2000);

    $('.minicart .popover').on('mouseleave', function () {
        if (popoverTimeout) {
            clearTimeout(popoverTimeout);
        }

        popoverTimeout = setTimeout(function () {
            $('.minicart .popover').removeClass('show');
            popoverTimeout = null;
        }, 2000);
    });
});

};
